import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
})
export class FileInputComponent {
  @Input() control!: AbstractControl;
  @Input() label = '';
  @Input() required = false;
  @Input() submitted = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() accept = '';
  @Input() uploadedFileName: string | null = null;

  @Output() fileChange = new EventEmitter<Event>();
  @Output() view = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();

  get isInvalid(): boolean {
    return !!(this.submitted && this.control && this.control.invalid);
  }
}
